<template><div><h1>vux-loader 插件列表</h1>
<h2>script-parser</h2>
<blockquote>
<p>.vue 文件的 script 部分代码处理</p>
</blockquote>
<pre class="hljs"><code>[{
 <span class="hljs-attr">name</span>: <span class="hljs-string">'script-parser'</span>,
 <span class="hljs-attr">fn</span>: <span class="hljs-function"><span class="hljs-keyword">function</span> (<span class="hljs-params">source</span>) </span>{
   <span class="hljs-keyword">return</span> source.replace(<span class="hljs-string">'VARIABLE'</span>, <span class="hljs-string">'v2'</span>)
 }
}]
</code></pre>
<h2>style-parser</h2>
<blockquote>
<p><code>&lt;style&gt;&lt;/style&gt;</code> 代码处理</p>
</blockquote>
<pre class="hljs"><code>[{
 <span class="hljs-attr">name</span>: <span class="hljs-string">'style-parser'</span>,
 <span class="hljs-attr">fn</span>: <span class="hljs-function"><span class="hljs-keyword">function</span> (<span class="hljs-params">source</span>) </span>{
   <span class="hljs-keyword">return</span> source.replace(<span class="hljs-string">'black'</span>, <span class="hljs-string">'white'</span>)
 }
}]
</code></pre>
<h2>template-parser</h2>
<blockquote>
<p>template代码替换处理</p>
</blockquote>
<blockquote>
<p>适用于对<code>&lt;template&gt;&lt;/template&gt;</code>模板代码做自定义处理</p>
</blockquote>
<ul>
<li>name 插件名字， <code>template-parser</code></li>
<li>replaceList 非必须，正则匹配列表，将直接调用 <code>replace</code> 方法进行替换</li>
<li>fn 非必须，相比params更灵活的方法，可以对字符串进行处理后返回</li>
</ul>
<p>插件配置：</p>
<pre class="hljs"><code>[
  name: <span class="hljs-string">"template-parser"</span>,
  <span class="hljs-attr">replaceList</span>: [{
    <span class="hljs-attr">test</span>: <span class="hljs-regexp">/DeathToPM/g</span>,
    <span class="hljs-attr">replaceString</span>: <span class="hljs-string">'微博-随时随地发现新鲜事'</span>
  }, {
    <span class="hljs-attr">test</span>: <span class="hljs-regexp">/呵呵我们压根没有底线/g</span>,
    <span class="hljs-attr">replaceString</span>: <span class="hljs-string">'我是有底线的'</span>
  }],
  <span class="hljs-attr">fn</span>: <span class="hljs-function"><span class="hljs-keyword">function</span> (<span class="hljs-params">templateSource</span>) </span>{
    <span class="hljs-keyword">return</span> templateSource.replace(<span class="hljs-string">'智障'</span>, <span class="hljs-string">'机智'</span>)
  }
]
</code></pre>
<h4>js-parser</h4>
<blockquote>
<p>项目里js文件处理，在babel-loader前进行处理</p>
</blockquote>
<pre class="hljs"><code>[{
 <span class="hljs-attr">name</span>: <span class="hljs-string">'js-parser'</span>,
 <span class="hljs-attr">fn</span>: <span class="hljs-function"><span class="hljs-keyword">function</span> (<span class="hljs-params">source</span>) </span>{
   <span class="hljs-keyword">return</span> source.replace(<span class="hljs-string">'black'</span>, <span class="hljs-string">'white'</span>)
 }
}]
</code></pre>
<h2>template-feature-switch</h2>
<p>实现根据变量切换template代码</p>
<p>参数：</p>
<ul>
<li><code>features</code>，变量列表，值只能为true或者false</li>
</ul>
<pre class="hljs"><code>{
  <span class="hljs-attr">name</span>: <span class="hljs-string">'template-feature-switch'</span>,
  <span class="hljs-attr">features</span>: {
    <span class="hljs-attr">feature1</span>: <span class="hljs-literal">true</span>,
    <span class="hljs-attr">feature2</span>: <span class="hljs-literal">false</span>
  }
}
</code></pre>
<pre class="hljs"><code><span class="hljs-tag">&lt;<span class="hljs-name">template</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">on</span> <span class="hljs-attr">feature</span>=<span class="hljs-string">"feature1"</span>&gt;</span>
      AWESOME FEATURE 1 is ON
    <span class="hljs-tag">&lt;/<span class="hljs-name">on</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">off</span> <span class="hljs-attr">feature</span>=<span class="hljs-string">"feature1"</span>&gt;</span>
      AWESOME FEATURE 1 is OFF
    <span class="hljs-tag">&lt;/<span class="hljs-name">off</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>
</code></pre>
<p>那么当 feature1 为 true时，将输出 <code>AWESOME FEATURE 1 is ON</code>, 反之则输出 <code>AWESOME FEATURE 1 is OFF</code>。注意<code>on</code>标签内不限定内容，可以为任何标签代码块，但<code>避免在on off 里面再嵌套 on off</code></p>
<h2>vux-ui</h2>
<p class="warning">
  vux组件的配套工具，如果没有使用vux, 不需要添加。
</p>
<p>如果配合<code>vux</code>使用，需要手动启用。默认不需要设置选项。</p>
<p>该插件做了以下处理：</p>
<ul>
<li>配置<code>babel</code>编译 vux 的js源码</li>
<li>修改vue-loader为 <code>vux-loader!vue-loader</code></li>
<li><code>import</code>组件调用解析为单组件引入</li>
</ul>
<pre class="hljs"><code>{
  name: 'vux-ui'
}
</code></pre>
<p>那么你就可以很方便地引入组件了：</p>
<pre class="hljs"><code>// 0.x
import Group from 'vux/src/components/group'
import Cell from 'vux/src/components/cell'

// 2.x
import { Group, Cell } from 'vux'
</code></pre>
<h2>i18n</h2>
<ol>
<li>
<p>如果你只是调用中文语言的vux组件，那么你不需要做任何配置。</p>
</li>
<li>
<p>如果你需要调用英文语言的vux组件，需要配置语言</p>
</li>
</ol>
<pre class="hljs"><code>{
  <span class="hljs-attr">name</span>: <span class="hljs-string">'i18n'</span>,
  <span class="hljs-attr">vuxStaticReplace</span>: <span class="hljs-literal">true</span>,
  <span class="hljs-attr">vuxLocale</span>: <span class="hljs-string">'en'</span>
}
</code></pre>
<ol start="3">
<li>如果你想和demo站点一样可以写<code>i18n</code>block，并且需要动态切换语言，那么需要配置插件抽取i18n的内容，并设置非静态替换</li>
</ol>
<pre class="hljs"><code>{
  <span class="hljs-attr">name</span>: <span class="hljs-string">'i18n'</span>,
  <span class="hljs-attr">vuxStaticReplace</span>: <span class="hljs-literal">false</span>,
  <span class="hljs-attr">staticReplace</span>: <span class="hljs-literal">false</span>,
  <span class="hljs-attr">extractToFiles</span>: <span class="hljs-string">'src/locales/components.yml'</span>,
  <span class="hljs-attr">localeList</span>: [<span class="hljs-string">'en'</span>, <span class="hljs-string">'zh-CN'</span>]
}
</code></pre>
<p>然后你就可以引用<code>vuex-i18n</code>插件实现多语言切换了。</p>
<p>参考 <a href="https://github.com/airyland/vux/blob/v2/src/main.js#L84-L96">main.js</a> 及 <a href="https://www.npmjs.com/package/vuex-i18n">vuex-i18n 文档</a>(仅当参考，你也可以使用其他i18n插件)。</p>
<h2>less-theme</h2>
<p class="warning">
注意，path所在文件必须是简单的less变量对，不能import其他文件或者引入变量。
</p>
<blockquote>
<p>less 变量设置和替换</p>
</blockquote>
<blockquote>
<p>适用于全局变量替换,  方便切换主题<br>
这意味着，你不再需要为每个页面引入全局的less文件了，你只需要设置lang为less就可以直接使用变量了</p>
</blockquote>
<pre class="hljs"><code>&lt;style lang=&quot;less&quot;&gt;
.info {
 color: @font-size;
}
&lt;/style&gt;
</code></pre>
<p>插件配置：</p>
<pre class="hljs"><code>{
  <span class="hljs-attr">name</span>: <span class="hljs-string">'less-theme'</span>,
  <span class="hljs-attr">path</span>: <span class="hljs-string">'src/styles/theme.less'</span>
}
</code></pre>
<h2>duplicate-style</h2>
<blockquote>
<p>css 重复代码清除</p>
</blockquote>
<p class="tip">
  建议使用vux组件的用户使用，因为vux直接引用less，最终构建的css文件确实会有冗余。
</p>
<blockquote>
<p>在webpack 构建完成后对生成的css文件使用cssnano进行重复样式清除。建议只在production环境下开启，因为dev环境没有必要。</p>
</blockquote>
<pre class="hljs"><code>{
  <span class="hljs-attr">name</span>: <span class="hljs-string">'duplicate-style'</span>,
  <span class="hljs-attr">events</span>: {
    <span class="hljs-attr">done</span>: <span class="hljs-function"><span class="hljs-keyword">function</span> (<span class="hljs-params"></span>) </span>{
      <span class="hljs-built_in">console</span>.log(<span class="hljs-string">'done!'</span>)
    }
  }
}
</code></pre>
<h2>html-build-callback</h2>
<blockquote>
<p>html文件处理事件回调</p>
</blockquote>
<blockquote>
<p>适用于在写入html(一般为index.html)文件前进行内容修改，比如替换特定内容<br>
比如写入js配置变量，改变cdn域名，将manifest文件直接写入html以减少请求等</p>
</blockquote>
<pre class="hljs"><code>{
  <span class="hljs-attr">name</span>: <span class="hljs-string">'html-build-callback'</span>,
  <span class="hljs-attr">events</span>: {
   <span class="hljs-string">'after-html-processing'</span>: <span class="hljs-function"><span class="hljs-keyword">function</span> (<span class="hljs-params">data, cb</span>) </span>{
      data.html += <span class="hljs-string">'magic footer'</span>
      cb(<span class="hljs-literal">null</span>, data)
   }
  }
}
</code></pre>
<p>可用事件请参考 <a href="https://www.npmjs.com/package/html-webpack-plugin">html-webpack-plugin</a></p>
<h2>build-done-callback</h2>
<blockquote>
<p>构建完成事件回调<br>
本质上是在webpack plugin的 done 事件后触发</p>
</blockquote>
<pre class="hljs"><code>{
 <span class="hljs-attr">name</span>: <span class="hljs-string">'build-done-callback'</span>,
 <span class="hljs-attr">fn</span>: <span class="hljs-function"><span class="hljs-keyword">function</span> (<span class="hljs-params"></span>) </span>{
   <span class="hljs-built_in">console</span>.log(<span class="hljs-string">'done!'</span>)
 }
}
</code></pre>
</div></template><script>
export default {
  head: {"title":"vux-loader 插件列表 | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// plugins-185.vue?1610ddcf